"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SignupSchema = void 0;

var Yup = _interopRequireWildcard(require("yup"));

var _utils = require("../utils");

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var SignupSchema = function SignupSchema(t, isNonUk, isFallback) {
  return Yup.object().shape({
    firstName: Yup.string().min(2, function () {
      return "".concat(t.firstName, " must be at least 2 ").concat(t.characters);
    }).max(50, function () {
      return "".concat(t.firstName, " must be at most 50 ").concat(t.characters);
    }).required((0, _utils.requiredError)(t.firstName, t.isRequiredError)),
    lastName: Yup.string().min(2, function () {
      return "".concat(t.lastName, " must be at least 2 ").concat(t.characters);
    }).max(50, function () {
      return "".concat(t.lastName, " must be at most 50 ").concat(t.characters);
    }).required((0, _utils.requiredError)(t.lastName, t.isRequiredError)),
    birthDate: Yup.string().required((0, _utils.requiredError)(t.birthDate, t.isRequiredError)).test("adult", t.birthDateError, function (value) {
      return (0, _utils.validateAge)(value, isFallback);
    }),
    mobileNumber: Yup.string().required((0, _utils.requiredError)(t.mobileNumber, t.isRequiredError)).min(10, function () {
      return "".concat(t.mobileNumber, " must be at least 10 ").concat(t.characters);
    }).max(16, function () {
      return "".concat(t.mobileNumber, " must be at most 16 ").concat(t.characters);
    }).test("isphone", t.changePhoneValidation, function (value) {
      return /^[/+0-9]*$/.test(value);
    }),
    mobileNumberConfirm: Yup.string().test("match", t.mobilesDontMatch, function (value, context) {
      return value === context.options.parent.mobileNumber;
    }),
    pin: Yup.string().required((0, _utils.requiredError)(t.pin, t.isRequiredError)).min(4, function () {
      return "".concat(t.pin, " must be at least 4 ").concat(t.characters);
    }).max(6, function () {
      return "".concat(t.pin, " must be at most 6 ").concat(t.characters);
    }).test("isnumber", t.changePinValidation, function (value) {
      return /^[0-9]*$/.test(value);
    }),
    pinConfirm: Yup.string().test("match", t.changePinDontMatch, function (value, context) {
      return value === context.options.parent.pin;
    }),
    agreedTerms: Yup.bool().oneOf([true], t.mustAgreeTerms),
    agreedPrivacy: Yup.bool().oneOf([true], t.mustAgreePrivacy),
    username: Yup.string().required((0, _utils.requiredError)(t.username, t.isRequiredError)).min(5, function () {
      return "".concat(t.username, " must be at least 5 ").concat(t.characters);
    }).max(30, function () {
      return "".concat(t.username, " must be at most 30 ").concat(t.characters);
    }),
    email: Yup.string().required((0, _utils.requiredError)(t.email, t.isRequiredError)).email(t.incorrectEmail),
    emailConfirm: Yup.string().test("match", t.unmatchEmail, function (value, context) {
      return value === context.options.parent.email;
    }),
    postcode: isNonUk ? Yup.string().notRequired() : Yup.string().required((0, _utils.requiredError)(t.postcode, t.isRequiredError)).min(5, function () {
      return "".concat(t.postcode, " must be at least 5 ").concat(t.characters);
    }).max(8, function () {
      return "".concat(t.postcode, " must be at most 8 ").concat(t.characters);
    }),
    street1: isNonUk ? Yup.string().notRequired() : Yup.string().required((0, _utils.requiredError)(t.street1, t.isRequiredError)),
    city: isNonUk ? Yup.string().notRequired() : Yup.string().required((0, _utils.requiredError)(t.city, t.isRequiredError)),
    password: Yup.string().required((0, _utils.requiredError)(t.password, t.isRequiredError)).min(8, function () {
      return "".concat(t.password, " must be at least 8 ").concat(t.characters);
    }).test("pass", t.incorrectPasswords, function (value, context) {
      return /[A-Z]/g.test(value) && /[0-9]/g.test(value) && /[a-z]/g.test(value);
    }),
    passwordConfirm: Yup.string().test("match", t.unmatchPasswords, function (value, context) {
      return value === context.options.parent.password;
    })
  });
};

exports.SignupSchema = SignupSchema;